// extracted by mini-css-extract-plugin
module.exports = {"controlCell":"style_controlCell__wrdoS","lastColumn":"style_lastColumn__2SH6b","scopeCell":"style_scopeCell__1tj5c","fullSizeCell":"style_fullSizeCell__3YMSG"};